import React from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../component/common/Loader";
import FileCreateStep1 from "./FileCreateStep1";
import FileDetailsStep2 from "./FileDetailsStep2";
import ReferencesStep3 from "./ReferencesStep3";
import { getCookie, getStorage } from "../../utils";
import CONSTANT from "../../constant";
import { getDepartmentList } from "../../actions/MasterAction";
import { getApprovingAuthority, getParkedFile } from "../../actions/UserAction";
import { getFileDetail } from "../../actions/FileAction";
import { Link } from "react-router-dom";

class MainFileCreate extends React.Component {
  constructor(props) {
    super(props);
    const userDetail = getCookie(CONSTANT.cookie.userDetail);
    const recipients = getStorage(CONSTANT.cookie.recipients);

    this.state = {
      currentStep: 1,
      showLoader: false,
      userDetail: userDetail,
      recipients,

      // Data collected from steps
      step1Data: null,
      step2Data: null,
      step3Data: null,

      // File code from step 1
      fileCode: null,
      action:null
    };
  }

  async componentDidMount() {
    try {
      document.title = CONSTANT.pageTitle.fileDetail;

      // Step 1: Load initial data
      const [deptRes, authRes, parkedFileRes] = await Promise.all([
        getDepartmentList(),
        getApprovingAuthority(),
        getParkedFile(),
      ]);

      // Step 2: Extract fileCode from URL and load file data
      const { search } = this.props.location;
      const params = new URLSearchParams(search);
      const fileCode = params.get("code");
      const action = params.get("action");

      if (!fileCode) {
        console.error("No file code found in URL");
        return;
      }

      this.setState({
        fileCode: fileCode,
        action:action,
        showLoader: true,
      });

      // Step 3: Load file details
      const res = await getFileDetail(fileCode);

      if (res.error) {
        alert(res.error);
        this.setState({ showLoader: false });
        return;
      }

      const {
        detail = {},
        to = [],
        department = [],
        approvers = [],
        attachments = [],
      } = res.result;
      // Format step1Data according to your Step1 component state structure
      this.setState({
        currentStep: detail?.hodApprovalStatus === "APPROVED" ? 2 : 1,
        step1Data: {
          fileCode: detail?.code,
          fileNumber: detail?.fileNumber,
          dated: detail?.dated,
          subject: detail?.subject,
          financialImplication: detail?.financialImplication,
        },
        step2Data: {
          approvingAuthority: approvers.length > 0 ? approvers[0].code : "",
          to: to,
          department: department,
          purposal: detail?.body,
          sheetType: detail?.sheetType,
          attachments: attachments,
        },
        step3Data: {
          referenceFiles: detail?.referenceFiles || [],
          parkedFile: JSON.parse(detail?.parkedFileAttached) || [],
          notifyEmail: detail?.notifyEmail,
          notifySMS: detail?.notifySMS,
        },
        showLoader: false,
      });

      // Update state with formatted step1Data
      // this.setState({
      //   // step1Data: step1Data,
      //   showLoader: false,
      // });
    } catch (err) {
      console.error("Error in componentDidMount:", err);
      this.setState({ showLoader: false });
    }
  }

  // Handle step 1 completion
  handleStep1Complete = (data) => {
    // this.setState({
    //   step1Data: data,
    //   fileCode: data.fileCode,
    //   currentStep: 2,
    // });
    setTimeout(() => {
      this.props.history.push(CONSTANT.component.DraftList.url);
    });
  };

  // Handle step 2 completion
  handleStep2Complete = (data) => {
    this.setState({
      step2Data: data,
      currentStep: 3,
    });
  };

  // Handle step 3 completion
  handleStep3Complete = (data) => {
    this.setState({
      step3Data: data,
    });

    // Final submission
    this.handleFinalSubmit();
  };

  // Handle save as draft
  handleSaveDraft = async () => {
    // Implement draft save logic
    toast.info("Saving as draft...");
  };

  // Final submission
  handleFinalSubmit = async () => {
    const { step1Data, step2Data, step3Data, fileCode } = this.state;

    // Combine all data
    const finalData = {
      ...step1Data,
      ...step2Data,
      ...step3Data,
      fileCode,
      saveAsDraft: false,
    };

    // Implement final submission logic
    console.log("Final submission data:", finalData);
    toast.success("File submitted successfully!");
  };

  // Navigate to previous step
  goToPrevStep = () => {
    this.setState((prevState) => ({
      currentStep: Math.max(1, prevState.currentStep - 1),
    }));
  };

  render() {
    const {
      currentStep,
      showLoader,
      userDetail,
      recipients,
      fileCode,
      step1Data,
    } = this.state;

    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="card homedob p-4 mb-4 pb-5">
              <div className="col-md-12 pl-0">
                <div className="tabbedt round mb-4">
  <ul>
    <li>
      <Link
        to={CONSTANT.component.userAddFile.url}
        className="active"
      >
        Create
      </Link>
    </li>

    <li>
      <Link
        to={CONSTANT.component.DraftList.url}
      >
        Submit for Approval
      </Link>
    </li>

    <li>
      <Link
        to={CONSTANT.component.myFiles.url}
      >
        My Files
      </Link>
    </li>

    <li>
      <Link
        to={CONSTANT.component.inbox.url}
      >
        Inbox
      </Link>
    </li>

    <li>
      <Link
        to={CONSTANT.component.outbox.url}
      >
        Outbox
      </Link>
    </li>
  </ul>
</div>
              </div>
              <div className="row mb-3">
                <div
                  className='col-12'
                >
                  <h1 className="page-title">
                    {fileCode
                      ? `Update File: ${
                          step1Data?.fileNumber
                            ? step1Data?.fileNumber + "/"
                            : ""
                        }${fileCode}`
                      : "Create New File"}
                  </h1>
                </div>
              </div>

              <div className="row">
                <div
                  className="col-12"
                >
                  <div className="card createfilepagebg">
                    <div className="card-body">
                      {/* Step 1 */}
                      <div>
                        {currentStep === 1 && (
                          <FileCreateStep1
                            fileCode={fileCode}
                            action={this.state.action}
                            userDetail={userDetail}
                            initialData={this.state.step1Data}
                            onStepComplete={this.handleStep1Complete}
                          />
                        )}
                      </div>

                      {/* Step 2 */}
                      {currentStep === 2 && (
                        <FileDetailsStep2
                          userDetail={userDetail}
                          initialData={this.state.step2Data}
                          recipients={recipients}
                          fileCode={fileCode}
                          onStepComplete={this.handleStep2Complete}
                          onPrevStep={this.goToPrevStep}
                        />
                      )}

                      {/* Step 3 */}
                      {currentStep === 3 && (
                        <ReferencesStep3
                          fileCode={fileCode}
                          userDetail={userDetail}
                          initialData={this.state.step3Data}
                          onStepComplete={this.handleStep3Complete}
                          onPrevStep={this.goToPrevStep}
                          onSaveDraft={this.handleSaveDraft}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {showLoader && <Loader />}
        <ToastContainer />
      </div>
    );
  }
}

export default MainFileCreate;
